(function () {
  var STORAGE_NAMESPACE = 'a3d_preview_image';
  var STORAGE_VERSION = '1';
  var MAX_ENTRIES = 12;
  var MAX_IMAGE_DIMENSION = 420;
  var PENDING_PREVIEW_ID = 'pending';
  var PENDING_META_KEY = STORAGE_NAMESPACE + ':' + STORAGE_VERSION + ':pending_meta';
  var PENDING_MAX_AGE_MS = 45 * 1000;
  var CROP_SCAN_MAX_DIMENSION = 240;
  var CROP_PADDING_PX = 12;
  var CROP_ALPHA_THRESHOLD = 16;
  var CROP_COLOR_TOLERANCE = 30;
  var inFlightProcessing = {};
  var lastCartData = null;
  var cartFetchPromise = null;

  function storageKey(tdaId) {
    return STORAGE_NAMESPACE + ':' + STORAGE_VERSION + ':' + tdaId;
  }

  function indexKey() {
    return STORAGE_NAMESPACE + ':' + STORAGE_VERSION + ':index';
  }

  function previewIdFromCartItemKey(itemKey) {
    return itemKey ? 'key:' + itemKey : null;
  }

  function safeGet(key) {
    try {
      return window.localStorage ? localStorage.getItem(key) : null;
    } catch (e) {
      return null;
    }
  }

  function safeSet(key, value) {
    try {
      if (!window.localStorage) return false;
      localStorage.setItem(key, value);
      return true;
    } catch (e) {
      return false;
    }
  }

  function safeRemove(key) {
    try {
      if (!window.localStorage) return;
      localStorage.removeItem(key);
    } catch (e) {}
  }

  function setPendingMeta(meta) {
    try {
      safeSet(PENDING_META_KEY, JSON.stringify(meta || {}));
    } catch (e) {}
  }

  function getPendingMeta() {
    var raw = safeGet(PENDING_META_KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function clearPending() {
    safeRemove(PENDING_META_KEY);
    safeRemove(storageKey(PENDING_PREVIEW_ID));
  }

  function loadIndex() {
    var raw = safeGet(indexKey());
    if (!raw) return [];
    try {
      var list = JSON.parse(raw);
      return list && typeof list.length === 'number' ? list : [];
    } catch (e) {
      return [];
    }
  }

  function saveIndex(list) {
    safeSet(indexKey(), JSON.stringify(list));
  }

  function touchIndex(tdaId) {
    var list = loadIndex();
    for (var i = 0; i < list.length; i++) {
      if (list[i] === tdaId) {
        list.splice(i, 1);
        break;
      }
    }
    list.push(tdaId);
    while (list.length > MAX_ENTRIES) {
      var removed = list.shift();
      safeRemove(storageKey(removed));
    }
    saveIndex(list);
  }

  function parseTdaIdFromUrl(url) {
    if (!url || typeof url !== 'string') return null;
    var clean = url.replace(/&amp;/g, '&');
    var match = clean.match(/[?&]tdaId=([^&#]+)/);
    if (!match || !match[1]) return null;
    try {
      return decodeURIComponent(match[1]);
    } catch (e) {
      return match[1];
    }
  }

  function getTdaIdFromCurrentPage() {
    return parseTdaIdFromUrl(window.location.href);
  }

  function findAngle3dButtonFromTarget(target) {
    var el = target;
    while (el && el !== document) {
      if (el.tagName && el.tagName.toLowerCase() === 'button' && el.id) {
        if (
          el.id.indexOf('tda-customizer-footer-atc-btn-') === 0 ||
          el.id.indexOf('tda-customizer-footer-buy-btn-') === 0
        ) {
          return el;
        }
      }
      el = el.parentNode;
    }
    return null;
  }

  function modelIdFromAngle3dButtonId(id) {
    if (!id) return null;
    var atcPrefix = 'tda-customizer-footer-atc-btn-';
    var buyPrefix = 'tda-customizer-footer-buy-btn-';
    if (id.indexOf(atcPrefix) === 0) return id.substring(atcPrefix.length);
    if (id.indexOf(buyPrefix) === 0) return id.substring(buyPrefix.length);
    return null;
  }

  function findModelViewer(modelId) {
    if (modelId) {
      var byId = document.getElementById('tda-app-section-model-viewer-' + modelId);
      if (byId) return byId;
    }
    var els = document.getElementsByTagName('tda-model-viewer');
    return els && els.length ? els[0] : null;
  }

  function tryGetScreenshotDataUrlSync(viewer) {
    if (!viewer) return null;
    try {
      if (typeof viewer.toDataURL === 'function') {
        var res = viewer.toDataURL();
        if (typeof res === 'string' && res.indexOf('data:image') === 0) return res;
      }
    } catch (e) {}

    var canvas = null;
    try {
      if (viewer.querySelector) canvas = viewer.querySelector('canvas');
    } catch (e) {}

    if (!canvas) {
      try {
        if (viewer.shadowRoot && viewer.shadowRoot.querySelector)
          canvas = viewer.shadowRoot.querySelector('canvas');
      } catch (e) {}
    }

    if (canvas && typeof canvas.toDataURL === 'function') {
      try {
        var data = canvas.toDataURL('image/png');
        if (data && data.indexOf('data:image') === 0) return data;
      } catch (e) {}
    }

    return null;
  }

  function resizeDataUrl(dataUrl, maxDim, callback) {
    if (!dataUrl || typeof dataUrl !== 'string') {
      callback(null);
      return;
    }

    var img = new Image();
    img.onload = function () {
      var w = img.naturalWidth || img.width;
      var h = img.naturalHeight || img.height;
      if (!w || !h) {
        callback(dataUrl);
        return;
      }

      var maxSide = w > h ? w : h;
      var scale = maxSide > maxDim ? maxDim / maxSide : 1;
      var cw = Math.max(1, Math.round(w * scale));
      var ch = Math.max(1, Math.round(h * scale));

      try {
        var canvas = document.createElement('canvas');
        canvas.width = cw;
        canvas.height = ch;
        var ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, cw, ch);
        var out = canvas.toDataURL('image/png');
        callback(out || dataUrl);
      } catch (e) {
        callback(dataUrl);
      }
    };

    img.onerror = function () {
      callback(dataUrl);
    };

    img.src = dataUrl;
  }

  function estimateBackgroundColor(data, w, h) {
    var samples = [
      [0, 0],
      [w - 1, 0],
      [0, h - 1],
      [w - 1, h - 1],
      [Math.floor(w / 2), 0],
      [Math.floor(w / 2), h - 1],
      [0, Math.floor(h / 2)],
      [w - 1, Math.floor(h / 2)]
    ];

    var sumR = 0;
    var sumG = 0;
    var sumB = 0;
    var count = 0;

    for (var i = 0; i < samples.length; i++) {
      var x = samples[i][0];
      var y = samples[i][1];
      if (x < 0 || y < 0 || x >= w || y >= h) continue;
      var idx = (y * w + x) * 4;
      var a = data[idx + 3];
      if (a <= CROP_ALPHA_THRESHOLD) continue;
      sumR += data[idx];
      sumG += data[idx + 1];
      sumB += data[idx + 2];
      count++;
    }

    if (!count) return { r: 255, g: 255, b: 255 };
    return {
      r: Math.round(sumR / count),
      g: Math.round(sumG / count),
      b: Math.round(sumB / count)
    };
  }

  function isBackgroundPixel(r, g, b, a, bg) {
    if (a <= CROP_ALPHA_THRESHOLD) return true;
    var dr = r - bg.r;
    var dg = g - bg.g;
    var db = b - bg.b;
    if (dr < 0) dr = -dr;
    if (dg < 0) dg = -dg;
    if (db < 0) db = -db;
    return (
      dr <= CROP_COLOR_TOLERANCE &&
      dg <= CROP_COLOR_TOLERANCE &&
      db <= CROP_COLOR_TOLERANCE
    );
  }

  function findContentBounds(data, w, h, bg) {
    var minX = w;
    var minY = h;
    var maxX = -1;
    var maxY = -1;
    var found = false;

    for (var y = 0; y < h; y++) {
      for (var x = 0; x < w; x++) {
        var idx = (y * w + x) * 4;
        var r = data[idx];
        var g = data[idx + 1];
        var b = data[idx + 2];
        var a = data[idx + 3];
        if (isBackgroundPixel(r, g, b, a, bg)) continue;
        found = true;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x > maxX) maxX = x;
        if (y > maxY) maxY = y;
      }
    }

    if (!found) return null;
    return { minX: minX, minY: minY, maxX: maxX, maxY: maxY };
  }

  function cropAndResizeDataUrl(dataUrl, maxDim, callback) {
    if (!dataUrl || typeof dataUrl !== 'string') {
      callback(null);
      return;
    }

    var img = new Image();
    img.onload = function () {
      var w = img.naturalWidth || img.width;
      var h = img.naturalHeight || img.height;
      if (!w || !h) {
        callback(dataUrl);
        return;
      }

      var scanMaxSide = w > h ? w : h;
      var scanScale = scanMaxSide > CROP_SCAN_MAX_DIMENSION ? CROP_SCAN_MAX_DIMENSION / scanMaxSide : 1;
      var sw = Math.max(1, Math.round(w * scanScale));
      var sh = Math.max(1, Math.round(h * scanScale));

      var scanCanvas;
      var scanCtx;
      try {
        scanCanvas = document.createElement('canvas');
        scanCanvas.width = sw;
        scanCanvas.height = sh;
        scanCtx = scanCanvas.getContext('2d');
        scanCtx.drawImage(img, 0, 0, sw, sh);
      } catch (e) {
        callback(dataUrl);
        return;
      }

      var scanData;
      try {
        scanData = scanCtx.getImageData(0, 0, sw, sh).data;
      } catch (e) {
        callback(dataUrl);
        return;
      }

      var bg = estimateBackgroundColor(scanData, sw, sh);
      var bounds = findContentBounds(scanData, sw, sh, bg);
      if (!bounds) {
        callback(dataUrl);
        return;
      }

      var mappedMinX = Math.max(0, Math.floor(bounds.minX / scanScale));
      var mappedMinY = Math.max(0, Math.floor(bounds.minY / scanScale));
      var mappedMaxX = Math.min(w - 1, Math.ceil((bounds.maxX + 1) / scanScale) - 1);
      var mappedMaxY = Math.min(h - 1, Math.ceil((bounds.maxY + 1) / scanScale) - 1);

      mappedMinX = Math.max(0, mappedMinX - CROP_PADDING_PX);
      mappedMinY = Math.max(0, mappedMinY - CROP_PADDING_PX);
      mappedMaxX = Math.min(w - 1, mappedMaxX + CROP_PADDING_PX);
      mappedMaxY = Math.min(h - 1, mappedMaxY + CROP_PADDING_PX);

      var cropW = mappedMaxX - mappedMinX + 1;
      var cropH = mappedMaxY - mappedMinY + 1;

      if (cropW <= 1 || cropH <= 1) {
        callback(dataUrl);
        return;
      }

      var maxSide = cropW > cropH ? cropW : cropH;
      var outScale = maxSide > maxDim ? maxDim / maxSide : 1;
      var outW = Math.max(1, Math.round(cropW * outScale));
      var outH = Math.max(1, Math.round(cropH * outScale));

      var isFullImage =
        mappedMinX === 0 && mappedMinY === 0 && mappedMaxX === w - 1 && mappedMaxY === h - 1;
      if (isFullImage && outScale === 1) {
        callback(dataUrl);
        return;
      }

      try {
        var outCanvas = document.createElement('canvas');
        outCanvas.width = outW;
        outCanvas.height = outH;
        var outCtx = outCanvas.getContext('2d');
        if (outCtx && typeof outCtx.imageSmoothingEnabled !== 'undefined') {
          outCtx.imageSmoothingEnabled = true;
          if (typeof outCtx.imageSmoothingQuality !== 'undefined') {
            outCtx.imageSmoothingQuality = 'high';
          }
        }
        outCtx.drawImage(img, mappedMinX, mappedMinY, cropW, cropH, 0, 0, outW, outH);
        var out = outCanvas.toDataURL('image/png');
        callback(out || dataUrl);
      } catch (e) {
        callback(dataUrl);
      }
    };

    img.onerror = function () {
      callback(dataUrl);
    };

    img.src = dataUrl;
  }

  function storePreview(tdaId, dataUrl) {
    if (!tdaId || !dataUrl) return false;
    var key = storageKey(tdaId);
    var ok = safeSet(key, dataUrl);
    if (ok) touchIndex(tdaId);
    return ok;
  }

  function getPreview(tdaId) {
    if (!tdaId) return null;
    return safeGet(storageKey(tdaId));
  }

  function getBestPendingImage(pendingMeta) {
    if (!pendingMeta) return null;
    if (pendingMeta.tdaId) {
      var fromTdaId = getPreview(pendingMeta.tdaId);
      if (fromTdaId) return fromTdaId;
    }
    return getPreview(PENDING_PREVIEW_ID);
  }

  function ensureProcessedPreview(tdaId, dataUrl, callback) {
    if (!tdaId || !dataUrl) {
      callback && callback(null);
      return;
    }

    if (inFlightProcessing[tdaId]) {
      if (callback) inFlightProcessing[tdaId].push(callback);
      return;
    }

    inFlightProcessing[tdaId] = callback ? [callback] : [];

    cropAndResizeDataUrl(dataUrl, MAX_IMAGE_DIMENSION, function (processed) {
      var finalDataUrl =
        processed && typeof processed === 'string' && processed.indexOf('data:image') === 0 ? processed : dataUrl;

      if (finalDataUrl !== dataUrl) storePreview(tdaId, finalDataUrl);

      var callbacks = inFlightProcessing[tdaId] || [];
      delete inFlightProcessing[tdaId];
      for (var i = 0; i < callbacks.length; i++) {
        try {
          callbacks[i](finalDataUrl);
        } catch (e) {}
      }
    });
  }

  function captureAndStoreForCurrentState(modelId) {
    var tdaId = getTdaIdFromCurrentPage();
    var viewer = findModelViewer(modelId);
    if (!viewer) return;

    setPendingMeta({ createdAt: Date.now(), tdaId: tdaId || null });
    safeRemove(storageKey(PENDING_PREVIEW_ID));

    var dataUrl = tryGetScreenshotDataUrlSync(viewer);
    if (dataUrl) {
      if (tdaId) {
        storePreview(tdaId, dataUrl);
        ensureProcessedPreview(tdaId, dataUrl);
      }

      storePreview(PENDING_PREVIEW_ID, dataUrl);
      setPendingMeta({ createdAt: Date.now(), tdaId: tdaId || null });
      return;
    }

    try {
      if (typeof viewer.toDataURL === 'function') {
        var maybe = viewer.toDataURL();
        if (maybe && typeof maybe.then === 'function') {
          maybe
            .then(function (result) {
              if (typeof result === 'string' && result.indexOf('data:image') === 0) {
                if (tdaId) {
                  storePreview(tdaId, result);
                  ensureProcessedPreview(tdaId, result);
                }

                storePreview(PENDING_PREVIEW_ID, result);
                setPendingMeta({ createdAt: Date.now(), tdaId: tdaId || null });
              }
            })
            ['catch'](function () {});
        }
      }
    } catch (e) {}
  }

  function applyPreviewToImg(img, dataUrl) {
    if (!img || !dataUrl) return;
    if (img.getAttribute('data-a3d-preview-applied') === dataUrl) return;

    img.setAttribute('data-a3d-preview-applied', dataUrl);
    img.setAttribute('src', dataUrl);
    img.src = dataUrl;
    img.setAttribute('data-src', dataUrl);

    img.removeAttribute('data-widths');
    img.removeAttribute('data-aspectratio');
    img.removeAttribute('data-sizes');
    img.removeAttribute('data-srcset');
    img.removeAttribute('srcset');

    if (typeof img.className === 'string') {
      img.className = img.className
        .replace(/\blazyload\b/g, '')
        .replace(/\blazystretch\b/g, '')
        .replace(/\s{2,}/g, ' ')
        .replace(/^\s+|\s+$/g, '');
    }
  }

  function updateCartPageImages() {
    var containers = document.querySelectorAll('.js-cart-items-container');
    if (!containers || !containers.length) return;

    for (var i = 0; i < containers.length; i++) {
      var container = containers[i];
      var link = container.querySelector('.tda-edit-customizer-btn');
      var tdaId = null;
      if (link) {
        var url = link.href || link.getAttribute('href');
        tdaId = parseTdaIdFromUrl(url);
      }

      var dataUrl = tdaId ? getPreview(tdaId) : null;
      var previewId = tdaId;

      if (!dataUrl) {
        var itemKey = container.getAttribute('data-cart-item-key');
        var keyPreviewId = previewIdFromCartItemKey(itemKey);
        if (keyPreviewId) {
          dataUrl = getPreview(keyPreviewId);
          previewId = keyPreviewId;
        }
      }

      if (!dataUrl || !previewId) continue;

      var img = container.querySelector('a.cart__image img');
      if (!img) continue;

      applyPreviewToImg(img, dataUrl);
      (function (imgEl, id, raw) {
        ensureProcessedPreview(id, raw, function (processed) {
          if (processed && processed !== raw) applyPreviewToImg(imgEl, processed);
        });
      })(img, previewId, dataUrl);
    }
  }

  function extractCustomizerUrlFromDrawerRow(row) {
    if (!row) return null;

    var directLink = row.querySelector('a.tda-edit-customizer-btn');
    if (directLink) return directLink.href || directLink.getAttribute('href');

    var metas = row.querySelectorAll('.ajaxcart__product-meta');
    if (!metas || !metas.length) return null;

    for (var i = 0; i < metas.length; i++) {
      var text = metas[i].textContent || '';
      if (text.indexOf('3D Customizer URL') === -1) continue;

      var match = text.match(/https?:\/\/\S+/);
      if (match && match[0]) return match[0];
    }

    return null;
  }

  function updateCartDrawerImages() {
    var rows = document.querySelectorAll('#CartDrawer .ajaxcart__row');
    if (!rows || !rows.length) return;

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      var url = extractCustomizerUrlFromDrawerRow(row);
      var tdaId = url ? parseTdaIdFromUrl(url) : null;

      var dataUrl = tdaId ? getPreview(tdaId) : null;
      var previewId = tdaId;

      if (!dataUrl) {
        var itemKey = row.getAttribute('data-cart-item-key');
        if (!itemKey) {
          var lineAttr = row.getAttribute('data-line');
          var line = lineAttr ? parseInt(lineAttr, 10) : null;
          if (line && lastCartData && lastCartData.items && lastCartData.items[line - 1] && lastCartData.items[line - 1].key) {
            itemKey = lastCartData.items[line - 1].key;
          } else if (line && !lastCartData) {
            fetchCartDataIfNeeded();
          }
        }
        var keyPreviewId = previewIdFromCartItemKey(itemKey);
        if (keyPreviewId) {
          dataUrl = getPreview(keyPreviewId);
          previewId = keyPreviewId;
        }
      }

      if (!dataUrl || !previewId) continue;

      var img = row.querySelector('.ajaxcart__product-image img');
      if (!img) continue;

      applyPreviewToImg(img, dataUrl);
      (function (imgEl, id, raw) {
        ensureProcessedPreview(id, raw, function (processed) {
          if (processed && processed !== raw) applyPreviewToImg(imgEl, processed);
        });
      })(img, previewId, dataUrl);
    }
  }

  function fetchCartDataIfNeeded() {
    if (lastCartData && lastCartData.items) return;
    if (cartFetchPromise) return;

    var cartUrl =
      window.theme && window.theme.routes && window.theme.routes.cart_url
        ? window.theme.routes.cart_url + '.js'
        : '/cart.js';

    if (window.fetch) {
      cartFetchPromise = window
        .fetch(cartUrl, { credentials: 'same-origin' })
        .then(function (res) {
          return res && res.ok && res.json ? res.json() : null;
        })
        .then(function (cart) {
          if (cart && cart.items) lastCartData = cart;
          return cart;
        })
        ['catch'](function () {
          return null;
        })
        .then(function () {
          cartFetchPromise = null;
          setTimeout(updateCartDrawerImages, 0);
        });
      return;
    }

    try {
      cartFetchPromise = true;
      var xhr = new XMLHttpRequest();
      xhr.open('GET', cartUrl, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState !== 4) return;
        try {
          if (xhr.status >= 200 && xhr.status < 300) {
            var cart = JSON.parse(xhr.responseText);
            if (cart && cart.items) lastCartData = cart;
          }
        } catch (e) {}
        cartFetchPromise = null;
        setTimeout(updateCartDrawerImages, 0);
      };
      xhr.send(null);
    } catch (e) {
      cartFetchPromise = null;
    }
  }

  function extractMainAddedCartItemKey(cartAddResponse) {
    if (!cartAddResponse || typeof cartAddResponse !== 'object') return null;

    if (cartAddResponse.items && cartAddResponse.items.length) {
      for (var i = 0; i < cartAddResponse.items.length; i++) {
        var item = cartAddResponse.items[i];
        if (!item) continue;
        var props = item.properties;
        var isParent =
          props && (props._isParent === 'true' || props._isParent === true || props._isParent === 'True');
        if (isParent && item.key) return item.key;
      }
      return cartAddResponse.items[0] && cartAddResponse.items[0].key ? cartAddResponse.items[0].key : null;
    }

    if (cartAddResponse.key) return cartAddResponse.key;
    if (cartAddResponse.item && cartAddResponse.item.key) return cartAddResponse.item.key;
    return null;
  }

  function handleCartAddResponse(cartAddResponse) {
    var pending = getPendingMeta();
    if (!pending || !pending.createdAt) return;
    if (Date.now() - pending.createdAt > PENDING_MAX_AGE_MS) {
      clearPending();
      return;
    }

    var itemKey = extractMainAddedCartItemKey(cartAddResponse);
    if (!itemKey) {
      clearPending();
      return;
    }

    var previewId = previewIdFromCartItemKey(itemKey);
    if (!previewId) {
      clearPending();
      return;
    }

    var dataUrl = getBestPendingImage(pending);
    if (!dataUrl) {
      clearPending();
      return;
    }

    storePreview(previewId, dataUrl);
    ensureProcessedPreview(previewId, dataUrl);
    clearPending();
  }

  function isCartAddUrl(url) {
    if (!url || typeof url !== 'string') return false;
    return url.indexOf('cart/add.js') !== -1;
  }

  function interceptFetch() {
    if (!window.fetch || window.fetch.__a3dPreviewPatched) return;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = args[0] && typeof args[0] === 'string' ? args[0] : args[0] && args[0].url ? args[0].url : null;
      return originalFetch.apply(this, args).then(function (res) {
        try {
          if (url && isCartAddUrl(url) && res && res.clone) {
            res
              .clone()
              .json()
              .then(function (data) {
                handleCartAddResponse(data);
              })
              ['catch'](function () {});
          }
        } catch (e) {}
        return res;
      });
    };
    window.fetch.__a3dPreviewPatched = true;
  }

  function interceptXhr() {
    if (!window.XMLHttpRequest) return;
    if (window.XMLHttpRequest.__a3dPreviewPatched) return;

    var originalOpen = window.XMLHttpRequest.prototype.open;
    var originalSend = window.XMLHttpRequest.prototype.send;

    window.XMLHttpRequest.prototype.open = function (method, url) {
      try {
        this.__a3dPreviewUrl = url;
        this.__a3dPreviewMethod = method;
      } catch (e) {}
      return originalOpen.apply(this, arguments);
    };

    window.XMLHttpRequest.prototype.send = function () {
      try {
        var xhr = this;
        if (xhr && xhr.__a3dPreviewUrl && isCartAddUrl(xhr.__a3dPreviewUrl) && !xhr.__a3dPreviewWrapped) {
          xhr.__a3dPreviewWrapped = true;
          var previousReadyStateChange = xhr.onreadystatechange;
          xhr.onreadystatechange = function () {
            try {
              if (xhr.readyState === 4) {
                if (xhr.responseText) {
                  try {
                    handleCartAddResponse(JSON.parse(xhr.responseText));
                  } catch (e) {
                    handleCartAddResponse(null);
                  }
                } else {
                  handleCartAddResponse(null);
                }
              }
            } catch (e) {}
            if (previousReadyStateChange) {
              return previousReadyStateChange.apply(this, arguments);
            }
          };
        }
      } catch (e) {}
      return originalSend.apply(this, arguments);
    };

    window.XMLHttpRequest.__a3dPreviewPatched = true;
  }

  interceptFetch();
  interceptXhr();
  (function () {
    var pending = getPendingMeta();
    if (pending && pending.createdAt && Date.now() - pending.createdAt > PENDING_MAX_AGE_MS) clearPending();
  })();

  function throttle(fn, wait) {
    var timeout = null;
    return function () {
      if (timeout) return;
      timeout = setTimeout(function () {
        timeout = null;
        fn();
      }, wait);
    };
  }

  function setupObservers() {
    if (!window.MutationObserver) return;

    var cartDrawer = document.getElementById('CartDrawer');
    if (cartDrawer) {
      var runDrawer = throttle(updateCartDrawerImages, 100);
      new MutationObserver(runDrawer).observe(cartDrawer, { childList: true, subtree: true });
    }

    var cartMain = document.querySelector('.cart__main-panel');
    if (cartMain) {
      var runCart = throttle(updateCartPageImages, 100);
      new MutationObserver(runCart).observe(cartMain, { childList: true, subtree: true });
    }
  }

  function bindThemeAjaxEvents() {
    if (!window.jQuery) return;

    window.jQuery('body').on(
      'theme:ajaxCart:addSuccess theme:ajaxCart:updateSuccess theme:ajaxCart:getCartSuccess',
      function (evt, cartOrResult) {
        if (cartOrResult && cartOrResult.items && typeof cartOrResult.item_count === 'number') {
          lastCartData = cartOrResult;
        }
        setTimeout(function () {
          updateCartPageImages();
          updateCartDrawerImages();
        }, 50);
      }
    );
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = findAngle3dButtonFromTarget(e.target);
      if (!btn) return;

      var modelId = modelIdFromAngle3dButtonId(btn.id);
      captureAndStoreForCurrentState(modelId);
    },
    true
  );

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(function () {
    updateCartPageImages();
    updateCartDrawerImages();
    setupObservers();
    bindThemeAjaxEvents();
  });
})();
